import FilterGroup from "@/theme1/components/shop/FilterGroup";
import PriceRange from "@/theme1/components/shop/PriceRange";

export default function FilterSidebar({
  filters,
  price,
  onFilterChange,
  onPriceChange,
  onClear,
  filterGroups = [],
}) {
  return (
    <aside className="hidden lg:block">
      <div className="sticky top-28 rounded-[2rem] border border-border/60 bg-white p-6 shadow-xl shadow-black/5">
        <div className="mb-2 flex items-center justify-between">
          <h2 className="text-lg font-semibold tracking-tight">Filters</h2>
          <button
            type="button"
            onClick={onClear}
            className="text-sm text-muted-foreground hover:text-foreground"
          >
            Clear
          </button>
        </div>

        <PriceRange value={price} onChange={onPriceChange} />

        {filterGroups.map((group) => (
          <FilterGroup
            key={group.id}
            group={group}
            selected={filters[group.id] || []}
            onChange={onFilterChange}
          />
        ))}
      </div>
    </aside>
  );
}
